export const visit = (vm, at) => {
at({ "de": { "priceComponents": { "pricePerMonth": "{{price}}/Monat", "pricePerMonth_New": "{{price}} pro Monat", "pricePerMonthPerSeat": "{{price}}/Monat/Lizenz", "pricePerMonthPerSeat_New": "{{price}} pro Monat pro Lizenz", "subtexts": { "startsAt": "Ab" } } } });
};